import { useState, useCallback } from "react";
import { EntityType } from "@/services/hooks/entities/useEntityType";

export interface NewDrawerState {
  isOpen: boolean;
  entityId: string | null;
  entityType: EntityType | null;
}

interface UseNewDrawerProps {
  onClose?: () => void;
}

export function useNewQuickViewDrawer({ onClose }: UseNewDrawerProps = {}) {
  const [drawerState, setDrawerState] = useState<NewDrawerState>({
    isOpen: false,
    entityId: null,
    entityType: null
  });

  const openDrawer = useCallback((entityId: string, entityType: EntityType) => {
    setDrawerState((prevState) => {
      // Toggle off if clicking the same entity
      if (prevState.isOpen && prevState.entityId === entityId) {
        return {
          isOpen: false,
          entityId: null,
          entityType: null
        };
      }
      return {
        isOpen: true,
        entityId,
        entityType
      };
    });
  }, []);

  const closeDrawer = useCallback(() => {
    onClose?.();
    setDrawerState({
      isOpen: false,
      entityId: null,
      entityType: null
    });
  }, [onClose]);

  return {
    drawerState,
    openDrawer,
    closeDrawer
  };
}
